import React from 'react'
import { formatedDate } from '../../../utils/formatedDate'
import styled from 'styled-components'
import { StyledCard } from '../../Cards/StyledCard'
import { useTranslation } from 'react-i18next'

const StyledMetaInfoBlock = styled(StyledCard)`
  font-size: 14px;
`

const StyledInfoItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const StyledInfoItem = styled.div`
  padding: 15px 25px;
  width: 200px;
`

const StyledMetaLabel = styled.div`
  font-weight: bold;
`
export default function MetaInfoBlock({ headerData }) {
  const { t } = useTranslation()
  if (!headerData) {
    return null
  }
  return (
    <StyledMetaInfoBlock>
      <StyledInfoItemsContainer>
        <div className='d-flex justify-content-between flex-wrap'>
          <div /*className='d-flex justify-content-between flex-grow-1'*/>
            <StyledInfoItem>
              <StyledMetaLabel>{t('withdrawalsTable:orderDate')}:</StyledMetaLabel>
              <div>{formatedDate(headerData.orderCreatedAt) ? formatedDate(headerData.orderCreatedAt) : null}</div>
            </StyledInfoItem>
          </div>
          <div>
            <StyledInfoItem>
              <StyledMetaLabel>{t('withdrawalsTable:orderNo')}:</StyledMetaLabel>
              <div>{headerData.orderNo}</div>
            </StyledInfoItem>
          </div>
          <div>
            <StyledInfoItem>
              <StyledMetaLabel>{t('withdrawalsTable:shippingNo')}:</StyledMetaLabel>
              <div>{headerData.shippingNo}</div>
            </StyledInfoItem>
          </div>
          <div>
            <StyledInfoItem>
              <StyledMetaLabel>{t('withdrawalsTable:recipient')}:</StyledMetaLabel>
              <div>{headerData?.recipient?.displayName}</div>
            </StyledInfoItem>
          </div>
          <div>
            <StyledInfoItem>
              <StyledMetaLabel>{t('orgaUnit')}:</StyledMetaLabel>
              <div>{headerData?.office?.displayName}</div>
            </StyledInfoItem>
          </div>
          <div>
            <StyledInfoItem>
              <StyledMetaLabel>{t('costcenter')}:</StyledMetaLabel>
              <div>{headerData?.costCenter?.displayName}</div>
            </StyledInfoItem>
          </div>
          <div>
            <StyledInfoItem>
              <StyledMetaLabel>{t('withdrawalsTable:warehouse')}:</StyledMetaLabel>
              <div>{headerData?.sourceStorehouse?.displayName}</div>
            </StyledInfoItem>
          </div>
        </div>
      </StyledInfoItemsContainer>
    </StyledMetaInfoBlock>
  )
}